import React from "react";
import { Box, Text, Heading, Image, Flex, Grid } from "@chakra-ui/react";
import service7 from "../../../assets/services/service7.jpg";
import service8 from "../../../assets/services/service8.jpg";
import flower1 from "../../../assets/services/SVG.png";


const Service3 = () => {
  return (
    <>
      <Box
        bg="#F7F1E6"
        color="black"
        minH="65vh"
        display="flex"
        alignItems="center"
        px={{ base: 4, md: 16 }}
        position="relative"
      >
        
        <Flex
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="space-between"
          w="100%"
          maxW="1200px"
          mx="auto"
          gap={8}
        >
          {/* Left: Text Section */}
          <Box
            flex="1"
            textAlign={{ base: "center", md: "left" }}
            mb={{ base: 6, md: 0 }}
          >
            <Heading fontSize={{ base: "2xl", md: "3xl" }} mb={4} className="fade-in-up">
              Social Media Marketing Make Your Brand the Talk of the Town!
            </Heading>

            <Text fontSize={{ base: "sm", md: "md" }} color="gray.700" className="fade-in-up">
            Social media is today’s marketplace, and we ensure your brand gets the limelight it deserves. From Facebook to Instagram, LinkedIn to Twitter, we create campaigns that make your brand go viral. Our secret? A unique blend of Marwadi wisdom and digital creativity!
            </Text>
          </Box>

          {/* Right: Image Section */}
          <Box
            flex="1"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
              gap={4}
              w="fit-content"
              position="relative"
            >
              <Box
                gridColumn={{ base: "auto", md: "2" }}
                gridRow={{ base: "1", md: "1" }}
                transform=""
                zIndex="1"
              >
                <Image
                  src={service7}
                  alt="Teamwork"
                  borderRadius="3xl"
                  boxShadow="lg"
                  w={{ base: "120px", md: "160px" }}
                  h={{ base: "120px", md: "140px" }}
                  objectFit="cover"
                  className="fade-in-up"
                />
              </Box>

              <Box
                gridColumn="1"
                gridRow="1"
                zIndex="1"
                transform="translateX(20%) translateY(40%)"
              >
                <Image
                  src={service8}
                  alt="Planning"
                  borderRadius="3xl"
                  boxShadow="lg"
                  w={{ base: "140px", md: "180px" }}
                  h={{ base: "140px", md: "160px" }}
                  objectFit="cover"
                  className="fade-in-up"
                />
              </Box>
            </Grid>
          </Box>
        </Flex>
        <Image
          src={flower1}
          alt="Decorative Flower"
          position="absolute"
          top={{ base: "75%", md: "15%" }}
          right={{ base: "23%", md: "7%" }}
          w={{ base: "90px", md: "240px" }}
          h={{ base: "90px", md: "260px" }}
          className="fade-in-up"
        />
      </Box>
    </>
  );
};

export default Service3;
